import { Component, computed, Input, signal, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TransactionType } from '../../../../../_interfaces/transactions.interface';

@Component({
  selector: 'app-transaction-export-confirmation-modal',
  standalone: true,
  templateUrl: './transaction-export-confirmation-modal.component.html',
})
export class TransactionExportConfirmationModalComponent {
  readonly ngbActiveModal = inject(NgbActiveModal);
  readonly router = inject(Router);

  private readonly _paymentType = signal<TransactionType | undefined>(undefined);

  @Input()
  set paymentType(value: TransactionType | undefined) {
    this._paymentType.set(value);
  }

  get paymentType() {
    return this._paymentType();
  }

  isExportingPayments = computed(() => this._paymentType() === TransactionType.PAY);

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  public onAccept(): void {
    this.ngbActiveModal.close(true);
  }

  protected async openExport(): Promise<void> {
    await this.router.navigate(['/accounting/transactions/export']);
    this.ngbActiveModal.dismiss();
  }
}
